import React, { useRef, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Grid } from "@mui/material";
import { Button } from "@dhis2/ui";
import InfoIcon from '@material-ui/icons/Info';
import Tooltip from '@mui/material/Tooltip';


const Glucose = (props) => {
    const glucoseChart = Array.isArray(props?.dashboardLineChart) ? props.dashboardLineChart : [];

    // Separate the data
    const randomBloodGlucose = glucoseChart.filter(item => item.indicatornames.includes("Random Blood Glucose"));
    const fastBloodGlucose = glucoseChart.filter(item => item.indicatornames.includes("Fast Blood Glucose"));

    // Function to format the series data
    function formatSeriesData(data) {
        const totalCounts = data.reduce((sum, item) => sum + item.counts, 0);
    return data.map(item => {
        const name = item.indicatornames.split('-')[0];
        const percent = Math.round(((item.counts / totalCounts) * 100).toFixed(2));
        return {
            value:item.counts,
            name: "",
            y: percent,
            color: name.includes("High") ? "#ff779e" : name.includes("Target")?"#203864":"#00acb1"
        };
        });
    }
// Fasting Blood Glucose Pie Chart
const piechart1 = {
    chart: {
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        backgroundColor: null,
        height:'320',
    },
    legend:{
    enabled: true,
    },
    exporting:{
        enabled: false,
    },
    credits:{
    enabled: false,
    },
    title: {
        text: 'FASTING BLOOD GLUCOSE',
        distance: -50,
        align: 'center',
        verticalAlign: 'middle',
        y: 100,
        style: {
            fontSize: '1.1em'
        }
    },
    tooltip: {
        enabled: false,
    },
    accessibility: {
        point: {
            valueSuffix: '%'
        }
    },
    plotOptions: {
        pie: {
            dataLabels: {
                enabled: true,
                format: '{point.y}% ({point.value})',
                connectorColor: 'silver',
                color: 'black'
                // distance: -50,
                // style: {
                //     fontWeight: 'bold',
                //     color: 'white'
                // }
            },
            startAngle: -90,
            endAngle: 90,
            center: ['50%', '75%'],
            size: '110%'
        }
    },
    series: [
    {
        type: 'pie',
        name: 'High (Poor control)',
        color:"#ff779e",
        innerSize: '50%',
        data: formatSeriesData(fastBloodGlucose)
    },
    ]
}
// Random Blood Glucose Pie Chart
const piechart2 = {
    chart: {
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        backgroundColor: null,
        height:'320',
    },
    exporting:{
        enabled: false,
    },
    legend:{
    enabled: true,
    },
    credits:{
    enabled: false,
    },
    title: {
        text: 'RANDOM BLOOD GLUCOSE',
        distance: -50,
        align: 'center',
        verticalAlign: 'middle',
        y: 100,
        style: {
            fontSize: '1.1em'
        }
    },
    tooltip: {
        enabled: false,
    },
    accessibility: {
        point: {
            valueSuffix: '%'
        }
    },
    plotOptions: {
        pie: {
            dataLabels: {
                enabled: true,
                format: '{point.y}% ({point.value})',
                connectorColor: 'silver',
                color: 'black'
                // distance: -50,
                // style: {
                //     fontWeight: 'bold',
                //     color: 'white'
                // }
            },
            startAngle: -90,
            endAngle: 90,
            center: ['50%', '75%'],
            size: '110%'
        }
    },
    series: [
    {
        type: 'pie',
        name: 'High (Poor control)',
        color:"#ff779e",
        innerSize: '50%',
        data: formatSeriesData(randomBloodGlucose)
    },
    ]
}
  return (
  <div className="">
            <div className="main-second-section mb-2">            
            <div className="heading">
                <h4 className="mt-0 mb-0"> PATIENTS WITH CONTROLLED AND UNCONTROLLED GLUCOSE (FOR YEAR 2024) </h4>
            </div>     
            <div className="main-icon">
                    <Tooltip title="Blood glucose levels (both random and fasting) of patients over time.">
                        <InfoIcon className="info-icon" />
                    </Tooltip>
                {/* <Button variant="contained" className="blue-icon">%</Button>
                <Button variant="contained" className="gray-icon">#</Button> */}
            </div>                   
        </div>

    <Grid container spacing={2}>
        <Grid item xs={6}>
        <div>
            <HighchartsReact 
            highcharts={Highcharts} 
            options={piechart1} />
        </div>
        </Grid>
        <Grid item xs={6}>
        <div>
            <HighchartsReact 
            highcharts={Highcharts} 
            options={piechart2} />
        </div>
        </Grid>
    </Grid>
    
    <div className="main-glucose-legend">
        <div className="main-glucose-legend">
            <div className="glucose-legend-c"></div>
            <p >Target Range (Good control)</p>
        </div>
        <div className="main-glucose-legend mx-24px">
            <p className="glucose-legend-unc"></p>
            <p>High (Poor control)</p>
        </div>
        <div className="main-glucose-legend mx-24px">
            <p className="glucose-legend-na"></p>
            <p>Needs Attention</p>
        </div>
    </div>
  </div>
      );
};

export default Glucose;